import type { JSX } from 'react'
import type { IButtonProps } from 'atoms/Button'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { IContainerHeaderProps } from '../ContainerHeader'

import { InlineForwardArrowWithTitle } from 'atoms/Button/Templates'
import { TextBoxMaxLine1Headline3 } from 'atoms/TextBox/Templates'
import { ContainerHeader } from '../ContainerHeader'
import {
  ContainerHeaderAlignItems,
  ContainerHeaderColumnGap,
} from '../ContainerHeader.h'

export interface IContainerHeaderLeftProps extends Omit<
  IContainerHeaderProps,
  'children'
> {
  title?: ITextBoxProps['title']
  controlsTitle?: IButtonProps['title']
}

export const ContainerHeaderLeft = ({
  title,
  controlsTitle,
  alignItems = ContainerHeaderAlignItems.Baseline,
  columnGap = ContainerHeaderColumnGap.INDENT_60,
  ...rest
}: IContainerHeaderLeftProps): JSX.Element => (
  <ContainerHeader alignItems={alignItems} columnGap={columnGap} {...rest}>
    <TextBoxMaxLine1Headline3 title={title || ''} />
    <InlineForwardArrowWithTitle title={controlsTitle || ''} />
  </ContainerHeader>
)
